import { fingerprintInit } from '@by-device/fingerprint';

import { useUserProfile } from './useUserProfile';

export function useFingerPrint() {
  const { profile } = useUserProfile();
  const fingerReport = async (function_id: string, action_id: string) => {
    await fingerprintInit();

    const ByFingerPrintReport = window.byDeviceTx.ByFingerPrintReport;

    ByFingerPrintReport({
      function_id,
      sign_type: action_id,
      account_name: profile?.result?.username as string,
      user_id: (profile?.result?.id as any) || '',
    });
  };
  return {
    fingerReport,
  };
}
